import queryString from "query-string";
import { CorrelationMatrixSettings, UrlQueryParams } from "store/types";

import { defaultCorrelationMatrixSettings } from "../constants";

export const correlationMatrixFromURL = (search: string): CorrelationMatrixSettings => {
  const filteredEmail = search.replace(/(email.+)\+/g, "%2B");
  const { correlationMatrixSettings }: UrlQueryParams = queryString.parseUrl(filteredEmail).query;

  const queries = correlationMatrixSettings ? (JSON.parse(correlationMatrixSettings) as CorrelationMatrixSettings) : {};
  return {
    ...defaultCorrelationMatrixSettings,
    ...queries
  };
};
